import { render, staticRenderFns } from "./files-tab.vue?vue&type=template&id=548ebcc9&scoped=true&"
import script from "./files-tab.vue?vue&type=script&lang=js&"
export * from "./files-tab.vue?vue&type=script&lang=js&"
import style0 from "./files-tab.vue?vue&type=style&index=0&id=548ebcc9&scoped=true&lang=css&"
import style1 from "./files-tab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ebcc9",
  null
  
)

export default component.exports